<template>
	<div class="view-wrapper home" v-if="document">
		<section class="intro">

			<div class="showreel__fallback-image" :style="'background-image:url(' + document.fallbackImage + ')'"></div>

			<video v-if="showVideo" :class="isEdge ? 'showreel__video is-not-object-fit' : 'showreel__video is-object-fit'" :playsinline="true" :autoplay="true" :muted="true" :loop="true">
				<source
					:src="document.native_video_webm.url"
					type="video/webm">
				<source
					:src="document.native_video_mp4.url"
					type="video/mp4">
			</video>

			<div class="intro__content">
				<div class="container">
					<h1>{{ document.title }}</h1>
					<h2>{{ document.subtitle }}</h2>
				</div>
			</div>
		</section>

		<section class="subjects">
			<div class="subjects__intro">
				<div class="container">
					<p>{{ document.intro }}</p>
				</div>
			</div>
			<div class="container">
				<c-services-list modifier="inverted"></c-services-list>
			</div>
		</section>
		<c-clients filter="featured"></c-clients>
		<c-project-list :featured="true" />
		<div :class="this.settings.currentLang === 'de-ch' ? 'container' : 'container container--spaced'">
			<router-link :to="settings.currentLang === 'de-ch' ? '/work/' : '/en/work/'" class="btn-projects">{{ localizedAllWorkButtonText }}</router-link>
		</div>
		<c-blog-posts-list :posts='featuredPosts' button="allPosts" compact="true" v-if="blogLoaded && settings.currentLang === 'de-ch'" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import getHomeData from '@/api/home.wp.api'
import CProjectList from '@/components/ProjectList'
import CBlogPostsList from '@/components/BlogPostsList'
import CClients from '@/components/Clients'
import CServicesList from '@/components/ServicesList'

export default {
	name: 'home',
	components: {
		CProjectList,
		CBlogPostsList,
		CClients,
		CServicesList
	},
	data: () => ({
		documentData: null,
		headData: defaultHeadData,
		showVideo: true,
		isEdge: false,
		outputPrint: '',
		allWorkButtonText: {
			'en-us': 'Show all work',
			'de-ch': 'Alle Arbeiten'
		}
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		},
		...mapGetters(['blogLoaded', 'featuredPosts']),
		localizedAllWorkButtonText() {
			return this.allWorkButtonText[this.settings.currentLang]
		}
	},
	watch: {
		'$route': function() {
			this.setHomeData()
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: true })
		}
	},
	beforeMount() {
		this.setHomeData()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en' })
	},
	mounted () {
		this.checkUserAgent()
	},
	methods: {
		setHomeData() {
			this.documentData = null
			getHomeData({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		},
		checkUserAgent() {
			const parse = require('ua-parser-js')
			const ua = parse(navigator.userAgent)
			const browser = ua.browser

			this.outputPrint = `name: ${browser.name}, version: ${browser.major}, engine: ${ua.engine.name}`
			if (browser.name === 'Samsung Browser') {
				this.showVideo = false
			}

			if (browser.name === 'Edge') {
				this.isEdge = true
			}
		},
		browserIsEdge() {
			const parse = require('ua-parser-js')
			const ua = parse(navigator.userAgent)
			const browser = ua.browser

			// this.outputPrint = `name: ${browser.name}, version: ${browser.major}, engine: ${ua.engine.name}`
			if (browser.name === 'Edge') return true

			return false
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.home .c-blog-posts-list {
		padding: 4rem 0;
	}
	.intro {
		box-sizing: border-box;
		height: 80vh;
		min-height: 30rem;
		max-height: 32rem;
		color: #fff;
		position: relative;
		overflow: hidden;
		margin-top: -9rem;

		@include mq($from: medium) {
			min-height: 35rem;
			max-height: 45rem;
		}


		&__content {
			padding-top: 11rem;

			h1, h2 {
				font-size: 1.75rem;
				font-weight: 600;
				color: #fff;

				@include mq($from: medium) {
					font-size: 3rem;
				}
			}
			h2 {
				max-width: 40rem;
			}

			@include mq($from: medium) {
				padding-top: 10rem;
			}
		}
	}
	.showreel {
		&__video {
			&.is-not-object-fit {
				position: absolute;
				left: 50%;
				top: 50%;
				min-width: 100%;
				min-height: 100%;
				width: auto;
				height: auto;
				transform: translate(-50%, -50%);
			}

			&.is-object-fit {
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				object-fit: cover;
				z-index: -1; // fixes overlapping bug
			}
		}
		&__fallback-image {
			background-color: $colorBrandMain;
			background-size: cover;
			background-position: center;
			width: 100%;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			z-index: -1;
		}
	}
	.btn-projects {
		border: 4px solid $colorBrandSecondary;
		display: block;
		width: 14rem;
		text-decoration: none;
		text-align: center;
		line-height: 2.5;
		margin: 2rem auto 0 auto;
		font-size: .9rem;
		font-weight: 600;

		&:hover {
			border-color: $colorBrandMain;
		}
	}
	.subjects	{
		background-color: $colorBrandSecondary;
		padding: 4rem 0 2rem 0;
		position: relative;

		&::before {
			content: "";
			display: block;
			background: $colorBrandSecondary;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			transform-origin: 0 0;
			transform: skew(0, -4deg);
		}

		@include mq($from: medium) {
			padding: 4rem 0 6rem;
		}


		&__intro {
			position: absolute;
			top: -3rem;
			left: 0;
			width: 100%;

			p {
				color: #fff;
				font-family: $fontFamilyBase;
				font-size: 1.75rem;
				max-width: 38rem;
				font-weight: 600;
				line-height: 1.1;
			}

			@include mq($from: medium) {
				top: -5rem;

				p {
					font-size: 3rem;
				}
			}
		}
	}

	.container.container--spaced {
		margin-bottom: 4rem;
	}

</style>



// WEBPACK FOOTER //
// Home.vue?7e3dcfa7